<template>

  <TheNavbar />

  <div v-if="thisBotHasError" class="row justify-content-center mt-4 mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
      <TheBotErrorsAlert />
    </div>
  </div>

  <div v-if="bot" class="row justify-content-center mt-5 mb-4">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

      <div class="card">
        <div class="card-header">
          <div class="row flex-between-end">
            <div class="col-auto text-center">
              <h5 class="mb-0" data-anchor="data-anchor">Edit Bot</h5>
            </div>
          </div>
        </div>
        <div class="card-body bg-body-tertiary">
          <p v-if="bot.exchangeId == 'hyperliquid'">
            This <span v-if="bot.tradingAccount == 'perpetual'">Futures</span><span v-else>Spot</span> Bot is connected to a <span class="fw-bold">{{ botExchange?.name }}</span> account.<br>
            <span class="fs-10">
              Public Address: <span class="fw-bold">{{ bot.exchangeConfig?.publicAddress }}</span><br>
              API Wallet Address: <span class="fw-bold">{{ bot.exchangeConfig?.apiKey }}</span>
            </span>
          </p>
          <p v-else>
            This <span v-if="bot.tradingAccount == 'perpetual'">Futures</span><span v-else>Spot</span> Bot is connected to a <span class="fw-bold">{{ botExchange?.name }}</span> sub-account.<br>
            <span class="fs-10">
              API Key: <span class="fw-bold">{{ bot.exchangeConfig?.apiKey }}</span>
            </span>
          </p>

          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-edit" role="tab" aria-controls="tab-edit" aria-selected="true">Edit Bot</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-add-funds" role="tab" aria-controls="tab-add-funds" aria-selected="false">Add Funds</a></li>
          </ul>
          <div class="tab-content border-top-0 pt-3">
            <div class="tab-pane fade show active" id="tab-edit" role="tabpanel">
              <BotEditForm @save="onSave" :key="id" :bot="bot" :loading="loadingUpdateBot" />
            </div>
            <div class="tab-pane fade" id="tab-add-funds" role="tabpanel">
              <ExchangeAddFundsInfo :bot="bot" />
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div v-if="bot && bot.tradingAccount != 'spot'" class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

      <div class="card">

        <div class="card-header">
          <div class="row flex-between-center">
            <div class="col-4 col-sm-auto d-flex align-items-center pe-0">
              <h5 class="fs-6 mb-0 text-nowrap py-2 py-xl-0">Positions</h5>
            </div>
            <div class="col-8 col-sm-auto ms-auto text-end ps-0">
              <div v-if="!loadingBotAssets">
                <a @click="refreshBotAssets" class="btn btn-primary btn-sm" type="button">
                  <span class="fas fa-sync-alt" data-fa-transform="shrink-3 down-2"></span>
                  Refresh
                </a>
              </div>
              <div v-if="loadingBotAssets">
                <div class="spinner-border">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <BotPositionsList v-if="botAssets" :key="id" :botAssets="botAssets" />
        </div>

        <!-- <div class="card-footer pb-1"></div> -->
      </div>

    </div>
  </div>

  <div v-if="bot" class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
      <div class="alert alert-primary mt-0 mb-0" role="alert">
        <span class="fw-bold">Want to test your Bot?</span>
        <br>
        Use our Signal Tester Strategy, which sends trading signals every 1 minute.<br>
        Watch this video to learn how to use it: <a href="https://www.youtube.com/watch?v=SnrtZBTQd_8" target="_blank"><span class="fw-bold">How to send test trading signals from TradingView to SIGNUM</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a>
      </div>
    </div>
  </div>

  <div v-if="bot" class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
      <div class="alert alert-primary mt-0 mb-0" role="alert">
        <span class="fw-bold">Need a trading strategy?</span>
        <br>
        Check our <router-link :to="{name: 'Strategies', params: {}}" class="" href=""><span class="fw-bold">Strategies</span></router-link> page or watch this YouTube video: <a href="https://www.youtube.com/watch?v=aXP-gsw7kxE" target="_blank"><span class="fw-bold">Automate the Gaussian Channel Strategy</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a>
      </div>
    </div>
  </div>

  <div v-if="bot" class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

      <div class="card">
        <div class="card-header">
          <div class="row flex-between-end">
            <div class="col-auto text-center">
              <h5>Trigger this Bot</h5>
            </div>
          </div>
        </div>
        <div class="card-body bg-body-tertiary">

          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-tv-strategy" role="tab" aria-controls="tab-tv-strategy" aria-selected="true">TradingView Strategy Alert</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-tv-custom-alerts" role="tab" aria-controls="tab-tv-custom-alerts" aria-selected="false">TradingView Custom Alerts</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-manual" role="tab" aria-controls="tab-manual" aria-selected="false">Manual</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-api" role="tab" aria-controls="tab-api" aria-selected="false">API</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-mcp" role="tab" aria-controls="tab-mcp" aria-selected="false">MCP</a></li>
          </ul>
          <div class="tab-content border-top-0 pt-3">
            <div class="tab-pane fade show active" id="tab-tv-strategy" role="tabpanel" aria-labelledby="video-tab">
              <p>For TradingView you need at least the <a href="https://www.tradingview.com/gopro?share_your_love=michaelionita" target="_blank"><span class="fw-bold">Essential</span></a> plan so you can create Alerts and use Webhooks.</p>

              <div class="d-flex justify-content-end mb-2">
                <CopyAiPromptButton :prompt="() => buildAiPromptForStrategy(bot)" />
              </div>

              <div class="form-floating mb-3">
                <input :value="bot.webhookDetailsBasic.alertName" @focus="$event.target.select()" class="form-control" type="text" placeholder="Alert Name" readonly>
                <label for="floatingInput">Alert Name</label>
              </div>

              <div class="">                
                <div class="text-start">
                  <label>Order Size</label>
                  <a href="https://youtu.be/vODuZmWFqxc" target="_blank" title="Video about how it works"><span class="fab fa-youtube" data-fa-transform="shrink-0_ grow-4 right-5 down-1"></span></a>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" v-model="positionSize" type="radio" name="radioPositionSize" value="1" />
                  <label class="form-check-label">100%</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" v-model="positionSize" type="radio" name="radioPositionSize" value="2" />
                  <label class="form-check-label">Let strategy decide</label>
                </div>
              </div>

              <div class="form-floating mb-3">
                <textarea @focus="$event.target.select()" class="form-control text-start_" style="min-height: 230px; white-space: pre;" readonly>{{ prettyTvStrategyJsonText(bot) }}</textarea>
                <label for="floatingInput">Alert Message</label>
                <p v-if="bot.tradingAccount == 'perpetual'" class="fs-10">This one Alert Message works for all signals your TradingView strategy will send to this Futures Bot (eg. long, short, close as well as take profit, stop loss orders). TradingView will replace the placeholders before sending the signal to SIGNUM.</p>
                <p v-else class="fs-10">This one Alert Message works for all signals your TradingView strategy will send to this Spot Bot (eg. long/buy, close/sell as well as take profit, stop loss orders). TradingView will replace the placeholders before sending the signal to SIGNUM.</p>
              </div>

              <div class="form-floating mb-3">
                <input :value="bot.webhookDetailsBasic.url" @focus="$event.target.select()" class="form-control" type="text" placeholder="Alert Name" readonly>
                <label for="floatingInput">Webhook URL</label>
              </div>

              <hr>

              <p>
                <span class="fw-bold">Watch this video</span> if you are doing it for the first time.
              </p>
              <iframe width="100%" height="420" src="https://www.youtube-nocookie.com/embed/XsQwD1H5NP8?si=GDEMo3y-ejOB46Lj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              
              <hr>
              
              <p>
                In TradingView, open the <span class="fw-bold">Strategy Report</span> on the bottom of your screen.
              </p>
              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_1.jpg" />
              <p>
                Click on the small arrow next to the strategy name to expand the drop-down menu and click on <span class="fw-bold">Add alert</span>.
                <br>
                Set the <span class="fw-bold">Expiration</span> date far into the future.
              </p>
              
              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_2.jpg" />
              <p>
                Click on <span class="fw-bold">Message</span> to edit it and paste the <span class="fw-bold">Alert Name</span> and the <span class="fw-bold">Alert Message</span>.
              </p>

              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_3.jpg" />
              <p>
                Go back and click on <span class="fw-bold">Notifications</span> to edit it and activate the <span class="fw-bold">Webhook URL</span> and paste the URL.<br>
                Click <span class="fw-bold">Apply</span>.
              </p>

              <p>
                Done 😊<br>
                <br>
                Now wait for the next trade to trigger (depends on your strategy), which will then trigger your Bot via the Webhook.
              </p>
            </div> <!-- tab -->
            <div class="tab-pane fade show" id="tab-tv-custom-alerts" role="tabpanel" aria-labelledby="video-tab">
              <p>For TradingView you need at least the <a href="https://www.tradingview.com/gopro?share_your_love=michaelionita" target="_blank"><span class="fw-bold">Essential</span></a> plan so you can create Alerts and use Webhooks.</p>

              <div class="d-flex justify-content-end mb-2">
                <CopyAiPromptButton :prompt="() => buildAiPromptForCustomAlerts(bot)" />
              </div>

              <div class="form-floating mb-3">
                <input :value="bot.webhookDetailsBasic.alertName" @focus="$event.target.select()" class="form-control" type="text" placeholder="Alert Name" readonly>
                <label for="floatingInput">Alert Name</label>
              </div>

              <div class="row gx-2">
                <div class="col-6">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyTvCustomAlertJsonText(bot, 'long') }}</textarea>
                    <label for="floatingInput">Open Long Message</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyTvCustomAlertJsonText(bot, 'closelong') }}</textarea>
                    <label for="floatingInput">Close Long Message</label>
                  </div>
                </div>
                <div class="col-6" v-if="bot.tradingAccount == 'perpetual'">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyTvCustomAlertJsonText(bot, 'short') }}</textarea>
                    <label for="floatingInput">Open Short Message</label>
                  </div>
                </div>
                <div class="col-6" v-if="bot.tradingAccount == 'perpetual'">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyTvCustomAlertJsonText(bot, 'closeshort') }}</textarea>
                    <label for="floatingInput">Close Short Message</label>
                  </div>
                </div>
              </div>

              <div class="form-floating mb-3">
                <input :value="bot.webhookDetailsBasic.url" @focus="$event.target.select()" class="form-control" type="text" placeholder="Alert Name" readonly>
                <label for="floatingInput">Webhook URL</label>
              </div>

              <hr>

              <p>
                In TradingView you can set up Alerts on "almost" anything, also on Trendlines.<br>
                <br>
                In the below example we show how to set up an <span class="fw-bold">Alert</span> for a <span class="fw-bold">Buy Signal</span> on a Trendline cross.<br>
                You can do the exact same for a <span class="fw-bold">Sell Signal</span> by simply using the <span class="fw-bold">Sell Message</span> instead (see above).
              </p>
              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_trendline_1.jpg" />
              <p>
                Draw your trendline (horizontally, diagonally or as you desire).
                <br>
                <span class="fw-bold">Right click</span> on it to open up the menu and click on <span class="fw-bold">Add alert</span>.
                <br>
                Set your desired <span class="fw-bold">Trigger</span> (Once per bar close is recommended).
                <br>
                Set the <span class="fw-bold">Expiration</span> date far into the future.
              </p>
              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_trendline_2.jpg" />
              <p>In the Alert, use the Buy or Sell message depending on your needs. In our example here, it's the Buy message.</p>
              <img class="img-fluid mb-3" src="@/assets/tradingview/setup_alert_trendline_3.jpg" />
              <p>
                Paste the <span class="fw-bold">Webhook URL</span> as shown.
                <br>
                Click <span class="fw-bold">Apply</span>.
              </p>
              <p>Done 😊</p>

            </div> <!-- tab -->
            <div class="tab-pane fade" id="tab-manual" role="tabpanel">
              <p>
                Trigger this Bot manually when you need to get in sync with your trading strategy.<br>
                When it is invested, so should your Bot and vice versa.<br>
                <br>
                These buttons trigger a trading signal as if your strategy sent it and all Bot settings (from above) will be respected (trading pair, leverage, etc.).
              </p>

              <div class="alert alert-warning mt-0 mb-3" role="alert">
                <span class="fw-bold">This feature is NOT meant to FOMO buy or FEAR sell using these buttons!</span>
                <br>
                It's not a trading interface or a replacement for one!<br>
                Remember, you are using SIGNUM to follow your strategy, not to mess with it 🫡
              </div>

              <div class="row text-center gx-2">
                <div class="col-12">
                  <label class="mb-1">Order Size (in %)</label>
                  <!-- <p class="fs-10 mb-1">
                    Text
                  </p> -->
                  <input v-model="manualPositionSize" class="form-range mb-3" type="range" min="1" max="100" />
                </div>
                <div class="col">
                  <div class="mb-1">
                    <button v-if="!loadingManualSignalLong" @click="sendTradingSignal('long', manualJsonSignal(bot, 'long', false))" type="submit" class="btn btn-success w-100">
                      <span>Long ({{ manualPositionSize }}%)</span>
                      <!-- <span v-if="bot.tradingAccount == 'perpetual'">Open Long ({{ manualPositionSize }}%)</span> -->
                      <!-- <span v-else>Buy ({{ manualPositionSize }}%)</span> -->
                    </button>
                    <div v-if="loadingManualSignalLong">
                      <div class="spinner-border">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-floating mb-3">
                    <textarea class="form-control" style="height: 230px; white-space: pre;" rows=6 readonly disabled>{{ manualJsonSignal(bot, 'long', true) }}</textarea>
                    <label for="floatingInput">Will execute this Signal</label>
                  </div>
                </div>
                <div class="col">
                  <div class="mb-1">
                    <button v-if="!loadingManualSignalReduce" @click="sendTradingSignal('reduce', manualJsonSignal(bot, 'reduce', false))" type="submit" class="btn btn-secondary w-100" :disabled="bot.tradingAccount == 'perpetual' && !getOpenBotPosition">
                      <span v-if="bot.tradingAccount == 'perpetual'">
                        <span v-if="manualPositionSize == 100">Close ({{ manualPositionSize }}%)</span>
                        <span v-else>Reduce ({{ manualPositionSize }}%)</span>
                      </span>
                      <span v-else>
                        <span v-if="manualPositionSize == 100">Close Long ({{ manualPositionSize }}%)</span>
                        <span v-else>Reduce Long ({{ manualPositionSize }}%)</span>
                      </span>
                    </button>
                    <div v-if="loadingManualSignalReduce">
                      <div class="spinner-border">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-floating mb-3">
                    <textarea class="form-control" style="height: 230px; white-space: pre;" rows=6 readonly disabled>{{ manualJsonSignal(bot, 'reduce', true) }}</textarea>
                    <label for="floatingInput">Will execute this Signal</label>
                  </div>
                </div>
                <div class="col-12 col-lg-4" v-if="bot.tradingAccount == 'perpetual'">
                  <div class="mb-1">
                    <button v-if="!loadingManualSignalShort" @click="sendTradingSignal('short', manualJsonSignal(bot, 'short', false))" type="submit" class="btn btn-danger w-100">
                      Short ({{ manualPositionSize }}%)
                    </button>
                    <div v-if="loadingManualSignalShort">
                      <div class="spinner-border">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-floating mb-3">
                    <textarea class="form-control" style="height: 230px; white-space: pre;" rows=6 readonly disabled>{{ manualJsonSignal(bot, 'short', true) }}</textarea>
                    <label for="floatingInput">Will execute this Signal</label>
                  </div>
                </div>
              </div>
            </div> <!-- tab -->
            <div class="tab-pane fade" id="tab-api" role="tabpanel">
              <p>
                Triggering this Bot via API is easy.<br>
                Send a <span class="fw-bold">POST</span> request with a <span class="fw-bold">JSON</span> Body to the <span class="fw-bold">Endpoint URL</span> shown below.<br>
                Make sure to add your server's <span class="fw-bold">IP address</span> to the bot's allow list (above), otherwise that signal "shall not pass" 🤪
              </p>

              <div class="row">
                <div class="col-12">
                  <div class="">                
                    <div class="text-start">
                      <label>Examples</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" v-model="apiExamples" type="radio" name="radioApiExamples" value="1" />
                      <label class="form-check-label">100% Order Size</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" v-model="apiExamples" type="radio" name="radioApiExamples" value="3" />
                      <label class="form-check-label">X% Order Size Partial</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" v-model="apiExamples" type="radio" name="radioApiExamples" value="4" />
                      <label class="form-check-label">Order Size Partial</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row gx-2">
                <div class="col-6">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyApiJsonText(bot, 'long') }}</textarea>
                    <label for="floatingInput">Open Long POST Body</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyApiJsonText(bot, 'closelong') }}</textarea>
                    <label for="floatingInput">Close Long POST Body</label>
                  </div>
                </div>
                <div class="col-6" v-if="bot.tradingAccount == 'perpetual'">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyApiJsonText(bot, 'short') }}</textarea>
                    <label for="floatingInput">Open Short POST Body</label>
                  </div>
                </div>
                <div class="col-6" v-if="bot.tradingAccount == 'perpetual'">
                  <div class="form-floating mb-2">
                    <textarea @focus="$event.target.select()" class="form-control text-start_" style="height: 230px; white-space: pre;" rows=6 readonly>{{ getPrettyApiJsonText(bot, 'closeshort') }}</textarea>
                    <label for="floatingInput">Close Short POST Body</label>
                  </div>
                </div>
              </div>
              
              <div class="form-floating mb-3">
                <input :value="bot.webhookDetailsBasic.url" @focus="$event.target.select()" class="form-control" type="text" placeholder="Alert Name" readonly>
                <label for="floatingInput">Endpoint URL</label>
              </div>
              
              <hr>

              <p>
                <span class="fw-bold">bot_id</span>* (String):<br>
                <br>
                Unique secret identifier for your bot. Keep private!
              </p>  
              
              <hr>
              
              <p>
                <span class="fw-bold">ticker</span>* (String):<br>
                <br>
                Guard-rail: Prevents routing a signal to the wrong pair. We allow common aliases & separators.<br>
                <br>
                Accepted: Any variant of the Bot's trading pair (e.g. <span class="badge badge-subtle-secondary">BTC/USD</span>, <span class="badge badge-subtle-secondary">BTCUSDT</span>, <span class="badge badge-subtle-secondary">BTC‑USDC</span>).<br>
                Rejected: Any different pair (e.g. <span class="badge badge-subtle-secondary">BTC/EUR</span>, <span class="badge badge-subtle-secondary">SOL/USDT</span>).<br>
              </p>
              <hr>
              <p>
                <span class="fw-bold">order_size</span>* (String):<br>
                <br>
                How much to buy or sell, always quoted in the base asset (contracts).<br>
                Supports percent of base balance (<span class="badge badge-subtle-secondary">"69%"</span>) or number of contracts (<span class="badge badge-subtle-secondary">"0.42"</span>).<br>
                <br>
                Exchanges require number of contracts when performing an order.<br>
                For percent <span class="badge badge-subtle-secondary">order_size</span>, SIGNUM will calculate the number of contracts dynamically for you, by first checking your exchange balance.
              </p>
              <hr>
              
              <p>
                <span class="fw-bold">position_size</span>* (String):<br>
                <br>
                Represents the desired position size AFTER the trade has been executed (the final state).<br>
                With this information, SIGNUM can validate if your current funds/position on the exchange plus/minus <span class="badge badge-subtle-secondary">order_size</span> results in your desired <span class="badge badge-subtle-secondary">position_size</span>.<br>
                <br>
                Possible values:<br>
                Value <span class="badge badge-subtle-secondary">&gt; 0</span> for going/staying long<br>
                Value <span class="badge badge-subtle-secondary">= 0</span> for going flat<br>
                Value <span class="badge badge-subtle-secondary">&lt; 0</span> for going/staying short**<br>
                <br>
                Example: <span class="badge badge-subtle-secondary">"0.12"</span>, <span class="badge badge-subtle-secondary">"0"</span>, <span class="badge badge-subtle-secondary">"-0.42"</span> for long, flat, short**.<br>
                <br>
                ** Shorting supported for Futures Bots.
              </p>
              <hr>
              <p>
                <span class="fw-bold">action</span>* (String):<br>
                <br>
                Send either <span class="badge badge-subtle-secondary">"buy"</span> or <span class="badge badge-subtle-secondary">"sell"</span> to indicate what you want your order to do.
              </p>
              <hr>
              <p>
                <span class="fw-bold">timestamp</span>* (String):
                <br>
                An ISO-8601 ISO timestamp, which prevents duplicate executions for the same signal in case it comes in more than once.
                <br>
                <br>
                Example: <span class="badge badge-subtle-secondary">"2024-09-16T10:15:00Z"</span>
              </p>
              <hr>
              <p>
                <span class="fw-bold">schema</span>* (String):
                <br>
                We version the JSON schema we support so that we can always remain backwards compatible with older schemas.<br>
                <br>
                Latest version is <span class="badge badge-subtle-secondary">"2"</span>.
              </p>
              <hr>
              <p>* Required</p>
            </div> <!-- tab -->
            <div class="tab-pane fade" id="tab-mcp" role="tabpanel">
              <p>
                Drive this Bot with an AI agent (like Claude) over the SIGNUM MCP. Pick a ready-made strategy prompt below, copy it, and run it in your AI agent - wrap it in a scheduled Routine to let it run automatically, hands-free.
              </p>

              <div class="mb-3">
                <label class="form-label mb-1">MCP URL</label>
                <div class="input-group">
                  <input :value="mcpUrl" @focus="$event.target.select()" class="form-control" type="text" readonly>
                  <button type="button" class="btn" :class="mcpUrlCopied ? 'btn-success' : 'btn-outline-primary'" style="min-width: 50px;" @click="copyMcpUrl">
                    <span v-if="mcpUrlCopied"><span class="fas fa-check me-1"></span>Copied</span>
                    <span v-else><span class="fas fa-copy me-1"></span></span>
                  </button>
                </div>
                <p class="fs-10 text-body-secondary mt-1 mb-0">Connect your AI agent (e.g. Claude) to SIGNUM using this MCP server URL.</p>
              </div>

              <!-- KPI numbers are real backtest figures (TradingView-style Max Drawdown). -->

              <!-- Crypto - Gaussian Channel (all users) -->
              <div class="card mb-3 border">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <div>
                      <h5 class="mb-1">Crypto · Gaussian Channel</h5>
                      <p class="fs-10 text-body-secondary mb-0">Upper-band crossover on the GC Trend Radar (top 50).</p>
                    </div>
                    <div class="d-none d-lg-block flex-shrink-0">
                      <CopyAiPromptButton :prompt="() => buildMcpPromptCryptoGc(bot)" />
                    </div>
                  </div>
                  <div class="d-flex flex-wrap gap-3 align-items-center" style="row-gap: 0.25rem;">
                    <div><span class="text-body-secondary">PnL</span> <span class="badge rounded-pill badge-subtle-success">+5,265%</span></div>
                    <div><span class="text-body-secondary">Max Drawdown</span> <span class="badge rounded-pill badge-subtle-danger">44.1%</span></div>
                  </div>
                  <div class="fs-10 mt-2">
                    <span class="badge rounded-pill badge-subtle-secondary">1D</span> <span class="badge rounded-pill badge-subtle-secondary">2018-01-01 → 2026-05-21</span>
                  </div>
                  <div class="d-flex justify-content-end mt-3 d-lg-none">
                    <CopyAiPromptButton :prompt="() => buildMcpPromptCryptoGc(bot)" />
                  </div>
                </div>
              </div>

              <!-- Crypto - Bot2Slow (AutoTrading members only) -->
              <div v-if="userProfileMix && userProfileMix.isAutotradingUser" class="card mb-3 border">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <div>
                      <h5 class="mb-1">Crypto · Bot2Slow <span class="badge badge-subtle-primary ms-1">AutoTrading</span></h5>
                      <p class="fs-10 text-body-secondary mb-0">Slow-line crossover on the B2S Trend Radar (top 100), breakout-recency sizing.</p>
                    </div>
                    <div class="d-none d-lg-block flex-shrink-0">
                      <CopyAiPromptButton :prompt="() => buildMcpPromptCryptoB2s(bot)" />
                    </div>
                  </div>
                  <div class="d-flex flex-wrap gap-3 align-items-center" style="row-gap: 0.25rem;">
                    <div><span class="text-body-secondary">PnL</span> <span class="badge rounded-pill badge-subtle-success">+10,231%</span></div>
                    <div><span class="text-body-secondary">Max Drawdown</span> <span class="badge rounded-pill badge-subtle-danger">39.8%</span></div>
                  </div>
                  <div class="fs-10 mt-2">
                    <span class="badge rounded-pill badge-subtle-secondary">1D</span> <span class="badge rounded-pill badge-subtle-secondary">2018-01-01 → 2026-05-21</span>
                  </div>
                  <div class="d-flex justify-content-end mt-3 d-lg-none">
                    <CopyAiPromptButton :prompt="() => buildMcpPromptCryptoB2s(bot)" />
                  </div>
                </div>
              </div>

              <!-- Stocks - Bot2Slow (AutoTrading members only) -->
              <div v-if="userProfileMix && userProfileMix.isAutotradingUser" class="card mb-3 border">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <div>
                      <h5 class="mb-1">Stocks · Bot2Slow <span class="badge badge-subtle-primary ms-1">AutoTrading</span></h5>
                      <p class="fs-10 text-body-secondary mb-0">Green-flip entry on the B2S Stocks Trend Radar (top 150).</p>
                    </div>
                    <div class="d-none d-lg-block flex-shrink-0">
                      <CopyAiPromptButton :prompt="() => buildMcpPromptStocksB2s(bot)" />
                    </div>
                  </div>
                  <div class="d-flex flex-wrap gap-3 align-items-center" style="row-gap: 0.25rem;">
                    <div><span class="text-body-secondary">PnL</span> <span class="badge rounded-pill badge-subtle-success">+506%</span></div>
                    <div><span class="text-body-secondary">Max Drawdown</span> <span class="badge rounded-pill badge-subtle-danger">16.3%</span></div>
                  </div>
                  <div class="fs-10 mt-2">
                    <span class="badge rounded-pill badge-subtle-secondary">1D</span> <span class="badge rounded-pill badge-subtle-secondary">2018-01-01 → 2026-05-21</span>
                  </div>
                  <div class="d-flex justify-content-end mt-3 d-lg-none">
                    <CopyAiPromptButton :prompt="() => buildMcpPromptStocksB2s(bot)" />
                  </div>
                </div>
              </div>

              <p class="fs-10 text-body-secondary mb-0">
                Past performance is not a guarantee for future results.
              </p>

              <h5 class="mt-3">Automate with Claude</h5>
              <div>
                <label class="form-label mb-1">Claude Connectors</label>
                <div class="input-group">
                  <span class="input-group-text"><img src="@/assets/logos/claude-logo.png" alt="Claude" width="18" height="18"></span>
                  <input value="https://claude.ai/customize/connectors" @focus="$event.target.select()" class="form-control" type="text" readonly>
                  <a href="https://claude.ai/customize/connectors" target="_blank" rel="noopener" class="btn btn-outline-primary" style="min-width: 50px;" title="Open Claude Connectors in a new tab">
                    <span class="fas fa-external-link-alt"></span>
                  </a>
                </div>
                <p class="fs-10 text-body-secondary mt-1 mb-0">Connect SIGNUM to Claude, one-time.</p>
              </div>

              <div class="mt-2">
                <label class="form-label mb-1">Claude Routines</label>
                <div class="input-group">
                  <span class="input-group-text"><img src="@/assets/logos/claude-logo.png" alt="Claude" width="18" height="18"></span>
                  <input value="https://claude.ai/code/routines" @focus="$event.target.select()" class="form-control" type="text" readonly>
                  <a href="https://claude.ai/code/routines" target="_blank" rel="noopener" class="btn btn-outline-primary" style="min-width: 50px;" title="Open Claude Routines in a new tab">
                    <span class="fas fa-external-link-alt"></span>
                  </a>
                </div>
                <p class="fs-10 text-body-secondary mt-1 mb-0">Open Claude Routines to schedule a prompt and let it run automatically, hands-free.</p>
              </div>

              
            </div> <!-- tab -->

          </div>
        </div>
      </div>

    </div>
  </div> <!-- row -->

  <div class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

      <div class="card">
        <div class="card-header">
          <div class="row flex-between-center">
            <div class="col-4 col-sm-auto d-flex align-items-center pe-0">
              <h5 class="fs-6 mb-0 text-nowrap py-2 py-xl-0">Bot Logs</h5>
            </div>
            <div v-if="botLogs" class="col-8 col-sm-auto ms-auto text-end ps-0">
              <div v-if="!loadingLogs">
                <a @click="refreshUserBotLogs" class="btn btn-primary btn-sm" type="button" title="Refresh logs">
                  <span class="fas fa-sync-alt" data-fa-transform="shrink-3 down-2"></span>
                  Refresh
                </a>
                <a @click="downloadLogsCsv" class="btn btn-secondary btn-sm ms-1" type="button" title="Download logs as CSV">
                  <span class="fas fa-download" data-fa-transform="shrink-3 down-2"></span>
                  CSV
                </a>
              </div>
              <div v-if="loadingLogs">
                <div class="spinner-border">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <BotLogList v-if="botLogs && userBots" :key="id" :botLogs="botLogs" :bots="userBots" />
        </div>

        <div v-if="botLogs.pages != 1 && botLogs.items?.length > 0" class="card-footer">
          <div class="d-flex align-items-center justify-content-center">
            <a v-if="!loadingLogs" @click="loadMoreUserLogs()" class="btn btn-secondary btn-sm" type="button" title="Doubles the amount of logs shown">
              <span class="fas fa-sync-alt" data-fa-transform="shrink-3 down-2"></span>
              Load more
            </a>
            <div v-if="loadingLogs">
              <div class="spinner-border">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

          </div>
        </div> <!-- footer -->

      </div>

    </div>
  </div> <!-- row -->

  <div v-if="bot" class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
      <TheLatencyAlert />
    </div>
  </div> <!-- row -->

  <div class="row justify-content-center mb-3">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

      <div class="card">
        <div class="card-header">
          <div class="row flex-between-center">
            <div class="col-12 d-flex align-items-center pe-0">
              <h5 class="fs-6 mb-0 text-nowrap text-truncate py-2 py-xl-0">Trading Alert Debugging</h5>
            </div>
          </div>
        </div>

        <div class="card-body bg-body-tertiary">
          <iframe width="100%" height="420" src="https://www.youtube.com/embed/RiyIcLCwrWk?si=RP33HYn1b_Qkh_VN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

      </div> <!-- card -->

    </div>
  </div> <!-- row -->

  <SimpleModal ref="modalRef" :loading="loadingManualSignalLong || loadingManualSignalReduce || loadingManualSignalShort" />
  
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import BotEditForm from '@/components/BotEditForm'
import BotLogList from '@/components/BotLogList'
import Tab from 'bootstrap/js/dist/tab.js'
import BotPositionsList from '@/components/BotPositionsList'
import TheBotErrorsAlert from '@/components/TheBotErrorsAlert'
import TheLatencyAlert from '@/components/TheLatencyAlert'
import SimpleModal from '@/components/SimpleModal'
import ExchangeAddFundsInfo from '@/components/ExchangeAddFundsInfo'
import CopyAiPromptButton from '@/components/CopyAiPromptButton'
import { downloadLogsCsv as exportLogsCsv } from '@/utils/exportLogsCsv'
import { userHelperMixin } from '@/mixins/userHelperMixin'
import { mcpPromptCryptoGc, mcpPromptCryptoB2s, mcpPromptStocksB2s } from '@/utils/mcpPrompts'

export default {
  mixins: [userHelperMixin],
  components: {
    TheNavbar,
    TheBotErrorsAlert,
    TheLatencyAlert,
    BotEditForm,
    BotLogList,
    BotPositionsList,
    SimpleModal,
    ExchangeAddFundsInfo,
    CopyAiPromptButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loadingBotAssets: false,
      loadingUpdateBot: false,
      loadingLogs: false,
      loadingManualSignalLong: false,
      loadingManualSignalReduce: false,
      loadingManualSignalShort: false,
      manualPositionSize: 100,
      userBotLogsPage: 1,
      userBotLogsLimit: 10,
      positionSize: 1,
      apiExamples: 1,
      mcpUrl: 'https://api.signum.money/mcp',
      mcpUrlCopied: false,
      mcpUrlCopyTimer: null,
    }
  },
  computed: {
    bot () {
      const bots = this.$store.getters.getUserBots
      if (bots) return bots.find(elem => elem.id+"" === this.id)
      return null
    },
    botLogs () {
      return this.$store.getters.getUserBotLogs(this.id)
    },
    userBots () {
      return this.$store.getters.getUserBots
    },
    botErrors () {
      return this.$store.getters.getUserBotErrors
    },
    thisBotHasError () {
      if (!this.botErrors || Object.keys(this.botErrors).length < 0) return false

      for (let botId in this.botErrors) {
        if (botId == this.bot.id) return true
      }

      return false
    },
    botAssets () {
      const botAssets = this.$store.getters.getUserBotAssets
      if (botAssets) return botAssets[this.bot.id] // Avoid an error we reloading the page by checking if not null
      else return null
    },
    botExchange () {
      return this.$store.state.platformExchanges?.find(elem => elem.id === this.bot.exchangeId)
    },
    getOpenBotPosition () {
      // If it's a bot which has an open position, we need to first find out if it's long or short so we know if we have to buy or sell to close the position
      const relevantBotPosition = this.botAssets?.positions?.find(elem => elem.baseCoin === this.bot.baseCoin)

      return relevantBotPosition
    },
    isBotLongOrShort () {
      const relevantBotPosition = this.getOpenBotPosition

      if (relevantBotPosition) return relevantBotPosition.direction
      return 'long'
    },
    manualJsonSignal () {
      return (bot, direction, pretty) => {
        let jsonText = bot.webhookDetailsAdvanced.message

        let jsonObj = JSON.parse(jsonText)
        jsonObj.ticker = (bot) ? bot.baseCoin+bot.quoteCoin : 'BTCUSD'
        
        jsonObj.order_size = this.manualPositionSize+"%"
        
        if (direction == 'long') {
          jsonObj.action = 'buy'
          jsonObj.position_size = '1'
        }
        if (direction == 'reduce') {
          if (this.isBotLongOrShort == 'short') jsonObj.action = 'buy'
          else jsonObj.action = 'sell'
          
          if (this.isBotLongOrShort == 'long' && jsonObj.action == 'sell' && this.manualPositionSize < 100) jsonObj.position_size = '1'
          else if (this.isBotLongOrShort == 'short' && jsonObj.action == 'buy' && this.manualPositionSize < 100) jsonObj.position_size = '-1'
          else jsonObj.position_size = '0'
        }
        if (direction == 'short') {
          jsonObj.action = 'sell'
          jsonObj.position_size = '-1'
        }

        jsonObj.timestamp = new Date().toISOString()

        if (pretty) return JSON.stringify(jsonObj, undefined, 2)
        
        return jsonObj
      }
    }
  },
  methods: {
    async onSave (event) {
      this.loadingUpdateBot = true
      await this.$store.dispatch('updateBot', event.newBot)
      this.loadingUpdateBot = false

      if (!event.stay) this.$router.push({ name: 'MyBots' })
    },
    async sendTradingSignal (direction, signalObj) {
      // console.log("signalObj", signalObj)

      // TODO: Give a better popup message to the user
      // let message = 'Please confirm this '+signalObj.order_size+' '+direction.toUpperCase()+' order.'
      // if (this.bot.tradingAccount == 'spot') {
      //   const directionForSpot = (direction == 'long')? 'BUY' : 'SELL'
      //   message = 'Please confirm this '+signalObj.order_size+' '+directionForSpot+' order.'
      // }

      let message = 'Please confirm this order.'

      this.$refs.modalRef.setValues({
        title: 'Confirm',
        message: message,
        callback: async () => {
          // Trigger loading animations
          if (direction == "long") this.loadingManualSignalLong = true
          else if (direction == "reduce") this.loadingManualSignalReduce = true
          else if (direction == "short") this.loadingManualSignalShort = true
          else {
            this.loadingManualSignalLong = true
            this.loadingManualSignalReduce = true
            this.loadingManualSignalShort = true
          }
    
          await this.$store.dispatch('sendTradingSignal', { signal: signalObj })
    
          // Now trigger refreshing what we need to refresh
          setTimeout(() => {
            this.refreshBotAssets()
            this.refreshUserBotLogs()
            
            this.loadingManualSignalLong = false
            this.loadingManualSignalReduce = false
            this.loadingManualSignalShort = false
          }, 5000);
        }
      })

      this.$refs.modalRef.toggleModal(true)
    },
    downloadLogsCsv () {
      exportLogsCsv(this.botLogs, this.userBots)
    },
    async refreshUserBotLogs () {
      this.loadingLogs = true
      await this.$store.dispatch('getUserBotLogs', { botId: this.id, page: this.userBotLogsPage, limit: this.userBotLogsLimit })
      this.loadingLogs = false
    },
    async refreshBotAssets () {
      this.loadingBotAssets = true
      await this.$store.dispatch('getBotAssets', { exchangeId: this.bot?.exchangeId, botId: this.bot?.id })
      this.loadingBotAssets = false
    },
    async loadMoreUserLogs () {
      this.loadingLogs = true
      this.userBotLogsLimit = this.userBotLogsLimit * 2
      await this.$store.dispatch('getUserBotLogs', { botId: this.id, page: this.userBotLogsPage, limit: this.userBotLogsLimit })
      this.loadingLogs = false
    },
    getPrettyTvCustomAlertJsonText (bot, direction) {
      const jsonText = bot.webhookDetailsBasic.message
      let jsonObj = JSON.parse(jsonText)
      if (direction == 'long'){
        jsonObj.action = "buy"
        jsonObj.order_size = "100%"
        jsonObj.position_size = "1"
      }
      if (direction == 'closelong'){
        jsonObj.action = "sell"
        jsonObj.order_size = "100%"
        jsonObj.position_size = "0"
      }
      if (direction == 'short'){
        jsonObj.action = "sell"
        jsonObj.order_size = "100%"
        jsonObj.position_size = "-1"
      }
      if (direction == 'closeshort'){
        jsonObj.action = "buy"
        jsonObj.order_size = "100%"
        jsonObj.position_size = "0"
      }

      return JSON.stringify(jsonObj, undefined, 2)
    },
    getPrettyApiJsonText (bot, direction) {
      let jsonText = bot.webhookDetailsAdvanced.message

      let jsonObj = JSON.parse(jsonText)
      jsonObj.ticker = (bot) ? bot.baseCoin+bot.quoteCoin : 'BTCUSD'

      if (this.apiExamples == 1) {
        if (direction == 'long') {
          jsonObj.action = "buy"
          jsonObj.order_size = "100%"
          jsonObj.position_size = "1"
        }
        if (direction == 'closelong') {
          jsonObj.action = "sell"
          jsonObj.order_size = "100%"
          jsonObj.position_size = "0"
        }
        if (direction == 'short') {
          jsonObj.action = "sell"
          jsonObj.order_size = "100%"
          jsonObj.position_size = "-1"
        }
        if (direction == 'closeshort') {
          jsonObj.action = "buy"
          jsonObj.order_size = "100%"
          jsonObj.position_size = "0"
        }
      }
      if (this.apiExamples == 3) {
        if (direction == 'long') {
          jsonObj.action = "buy"
          jsonObj.order_size = "25%"
          jsonObj.position_size = "1"
        }
        if (direction == 'closelong') {
          jsonObj.action = "sell"
          jsonObj.order_size = "80%"
          jsonObj.position_size = "1"
        }
        if (direction == 'short') {
          jsonObj.action = "sell"
          jsonObj.order_size = "25%"
          jsonObj.position_size = "-1"
        }
        if (direction == 'closeshort') {
          jsonObj.action = "buy"
          jsonObj.order_size = "80%"
          jsonObj.position_size = "-1"
        }
      }
      if (this.apiExamples == 4) {
        if (direction == 'long') {
          jsonObj.action = "buy"
          jsonObj.order_size = "0.5"
          jsonObj.position_size = jsonObj.order_size
        }
        if (direction == 'closelong') {
          jsonObj.action = "sell"
          jsonObj.order_size = "0.1"
          jsonObj.position_size = "0.4"
        }
        if (direction == 'short') {
          jsonObj.action = "sell"
          jsonObj.order_size = "0.5"
          jsonObj.position_size = "-0.5"
        }
        if (direction == 'closeshort') {
          jsonObj.action = "buy"
          jsonObj.order_size = "0.1"
          jsonObj.position_size = "-0.4"
        }
      }

      jsonObj.timestamp = new Date().toISOString()
      
      return JSON.stringify(jsonObj, undefined, 2)
    },
    prettyTvStrategyJsonText (bot) {
      let jsonText = (this.positionSize == 1)? bot.webhookDetailsBasic.message : bot.webhookDetailsAdvanced.message
      const jsonObj = JSON.parse(jsonText)

      return JSON.stringify(jsonObj, undefined, 2)
    },
    async copyMcpUrl () {
      try {
        await navigator.clipboard.writeText(this.mcpUrl)
        this.mcpUrlCopied = true
        if (this.mcpUrlCopyTimer) clearTimeout(this.mcpUrlCopyTimer)
        this.mcpUrlCopyTimer = setTimeout(() => { this.mcpUrlCopied = false }, 2000)
      } catch (e) {
        console.error('Clipboard write failed:', e)
      }
    },
    buildMcpPromptCryptoGc (bot) { return mcpPromptCryptoGc(bot.id) },
    buildMcpPromptCryptoB2s (bot) { return mcpPromptCryptoB2s(bot.id) },
    buildMcpPromptStocksB2s (bot) { return mcpPromptStocksB2s(bot.id) },
    buildAiPromptForStrategy (bot) {
      const isPerpetual = bot.tradingAccount == 'perpetual'
      const alertName = bot.webhookDetailsBasic.alertName
      const webhookUrl = bot.webhookDetailsBasic.url
      const basicMessage = JSON.stringify(JSON.parse(bot.webhookDetailsBasic.message), undefined, 2)
      const advancedMessage = JSON.stringify(JSON.parse(bot.webhookDetailsAdvanced.message), undefined, 2)

      let prompt = `Please create a TradingView Alert for [[ STRATEGY TITLE ]], configured as follows:\n`
      prompt += `\n`
      prompt += `Alert Name: ${alertName} ([[ SHORTENED STRATEGY TITLE ]])\n`
      prompt += `Webhook URL: ${webhookUrl}\n`
      prompt += `Expiration: Open-ended if possible otherwise as far into the future as possible\n`
      prompt += `\n`
      prompt += `Alert Message — Basic Variant (use this for "% order sizes", which is the most common setup):\n${basicMessage}\n`
      prompt += `\n`
      prompt += `Alert Message — Advanced Variant (use this for "absolute order sizes", which supports partial position sizes driven by the TradingView strategy):\n${advancedMessage}\n`
      prompt += `\n`
      prompt += `How "order_size" works:\n`
      prompt += `How much to buy or sell and always quoted in the base asset (contracts).\n`
      prompt += `Supports percent of base balance ("69%") or number of contracts ("0.42").\n`
      prompt += `Exchanges require the number of contracts to perform an order, so for percent order_size SIGNUM will calculate the number of contracts dynamically for you, by first checking your exchange balance before sending the order.\n`
      prompt += `Work with % order_size as much as you can as it causes the least order size errors down the line.\n`
      prompt += `\n`
      prompt += `Important notes:\n`
      prompt += `- TradingView will replace the {{ }} placeholders, you don't need to touch them.\n`
      prompt += `- You replace the [[ ]] placeholders (if any) by yourself to fit our context.\n`
      prompt += `- Use only ONE of the two Alert Messages above (pick Basic unless the user explicitly wants partial position sizing or the strategy the user is automating requires it).\n`
      prompt += `- This single alert covers all order types the TradingView strategy will send ${ isPerpetual ? '(long, short, close, take profit and stop loss)' : '(long, close, take profit and stop loss)' } because TradingView will replace the {{ }} placeholders accordingly.\n`
      prompt += `- In the Alert Messages (Basic Variant) you can adapt the order_size to match how you want the orders to be placed. Default is "100%" for all-in and all-out orders.\n`
      prompt += `- The alert must be attached to a TradingView strategy (not an indicator, trendline or price level).\n`
      prompt += `- Enable the Webhook URL option under Notifications and paste the Webhook URL above.\n`
      return prompt
    },
    buildAiPromptForCustomAlerts (bot) {
      const isPerpetual = bot.tradingAccount == 'perpetual'
      const alertName = bot.webhookDetailsBasic.alertName
      const webhookUrl = bot.webhookDetailsBasic.url

      const longMsg = this.getPrettyTvCustomAlertJsonText(bot, 'long')
      const closeLongMsg = this.getPrettyTvCustomAlertJsonText(bot, 'closelong')
      const shortMsg = isPerpetual ? this.getPrettyTvCustomAlertJsonText(bot, 'short') : null
      const closeShortMsg = isPerpetual ? this.getPrettyTvCustomAlertJsonText(bot, 'closeshort') : null

      // const alertCount = isPerpetual ? 4 : 2

      let prompt = `For the LONG trade, please set up the corresponding TradingView Alerts.\n`
      prompt += `\n`
      prompt += `Alert Name: ${alertName} ([[ Trade direction/action ]])\n`
      prompt += `Webhook URL: ${webhookUrl}\n`
      prompt += `Expiration: Open-ended if possible otherwise as far into the future as possible\n`
      prompt += `Trigger: Every time\n`
      prompt += `\n`
      prompt += `Alert Message to Open Long:\n${longMsg}\n`
      prompt += `\n`
      prompt += `Alert Message to Close Long:\n${closeLongMsg}\n`
      if (isPerpetual) {
        prompt += `Alert Message to Open Short:\n${shortMsg}\n`
        prompt += `\n`
        prompt += `Alert Message to Close Short:\n${closeShortMsg}\n`
      }
      prompt += `\n`
      prompt += `How "order_size" works:\n`
      prompt += `How much to buy or sell and always quoted in the base asset (contracts).\n`
      prompt += `Supports percent of base balance ("69%") or number of contracts ("0.42").\n`
      prompt += `Exchanges require the number of contracts to perform an order, so for percent order_size SIGNUM will calculate the number of contracts dynamically for you, by first checking your exchange balance before sending the order.\n`
      prompt += `Work with % order_size as much as you can as it causes the least order size errors down the line.\n`
      prompt += `\n`
      prompt += `How "position_size" works:\n`
      prompt += `Represents the desired position size AFTER the trade has been executed (the final state).\n`
      prompt += `With this information, SIGNUM can validate if your current funds/position on the exchange plus/minus order_size results in your desired position_size.\n`
      prompt += `Possible values:\n`
      prompt += `Value > 0 for going/staying long (e.g "0.25")\n`
      prompt += `Value = 0 for going flat ("0")\n`
      if (isPerpetual) {
        prompt += `Value < 0 for going/staying short (e.g "-0.42")\n`
      }
      prompt += `\n`
      prompt += `How "action" works:\n`
      prompt += `Send either "buy" or "sell" to indicate what you want your order to do.\n`
      prompt += `\n`
      prompt += `Important notes:\n`
      prompt += `- TradingView will replace the {{ }} placeholders, you don't need to touch them.\n`
      prompt += `- You replace the [[ ]] placeholders (if any) by yourself to fit our context.\n`
      prompt += `- For multiple take profits and stop losses, it makes sense for you to adapt the order_size for each one. Default is "100%" for all-in and all-out orders.\n`
      prompt += `- For each alert pick the appropriate Alert Message fitting the trade (e.g. enter, exit, take profit, stop loss etc.).\n`
      prompt += `- For each alert, enable the Webhook URL option under Notifications and paste the Webhook URL above.\n`
      return prompt
    },
  },
  async created () {
    // If store data is missing, fetch it
    if (!this.$store.getters.getUserBots) await this.$store.dispatch('getUserBots')
    if (!this.$store.state.platformExchanges) await this.$store.dispatch('getPlatformExchanges')
  },
  mounted () {
    console.debug(Tab) // Must use Tab but don't actually need that object as it initializes itself
    this.refreshUserBotLogs()
    this.refreshBotAssets()

    if (this.$route.query.cameFrom == 'createBot') {
      this.$confetti.start()
      setTimeout(() => {
        this.$confetti.stop()
      }, "2000");
    }
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }
}
</script>